// src/modules/components/reports/calls/CallReportsFilter.js
import React from "react";
import {
  Filter,
  SelectInput,
  TextInput,
  SearchInput,
} from "react-admin";

const CallReportsFilter = (props) => (
  <Filter {...props}>
    <SearchInput 
      source="q" 
      alwaysOn 
      placeholder="Search by caller, destination, or agent..." 
    />
    <SelectInput
      source="callType"
      label="Call Type"
      choices={[
        { id: 'incoming', name: 'Incoming' },
        { id: 'outgoing', name: 'Outgoing' },
        { id: 'internal', name: 'Internal' },
        { id: 'unknown', name: 'Unknown' },
      ]}
      allowEmpty
      alwaysOn
    />
    <SelectInput
      source="disposition"
      label="Status"
      choices={[
        { id: 'ANSWERED', name: 'Answered' },
        { id: 'NO ANSWER', name: 'No Answer' },
        { id: 'BUSY', name: 'Busy' },
        { id: 'FAILED', name: 'Failed' },
      ]}
      allowEmpty
      alwaysOn
    />
    <TextInput 
      source="src" 
      label="Caller" 
      alwaysOn 
      placeholder="Enter caller number..." 
    />
    <TextInput 
      source="dst" 
      label="Destination" 
      alwaysOn 
      placeholder="Enter destination number..." 
    />
    <TextInput 
      source="agentId" 
      label="Agent ID" 
      alwaysOn 
      placeholder="Enter agent ID..." 
    />
  </Filter>
);

export default CallReportsFilter;